import axios from "axios";
import { APIAddress } from "constants/config";

export default function getPaymentMethod() {

	return new Promise((resolve, reject) => {
		axios.put(APIAddress, {'uri': `/payment_method/`,
		'method': 'GET',
		'token': localStorage.getItem('token')})
		.then((res) => {
			resolve(res.data);
		})
		.catch((err) => {
			reject(err);
		})
	})
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/payment/getPaymentMethod.js